import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import dayjs from 'dayjs';

import 'dayjs/locale/ru.js';

import RU from './translations/ru.json';
import { dateFormatter, Formatter, phoneFormatter } from './formatters';
import { Language } from './constants';

dayjs.locale('ru');

const resources = {
  ru: {
    translation: { ...RU },
  },
};

export const currentLanguage = (): Language => {
  return i18n.language as Language;
};

export const initI18 = () => {
  return i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      resources,
      fallbackLng: 'ru',
      interpolation: {
        escapeValue: false,
      },
      react: {
        bindI18n: 'languageChanged',
        bindI18nStore: '',
        transEmptyNodeValue: '',
        transSupportBasicHtmlNodes: true,
        transKeepBasicHtmlNodesFor: ['br', 'b', 'i', 'strong'],
        useSuspense: true,
      },
    })
    .then(() => {
      i18n.services.formatter?.add(Formatter.PHONE, phoneFormatter);
      i18n.services.formatter?.add(Formatter.DATE, dateFormatter);

      // const lng = i18n.language as Language;
      //
      // dayjs.locale(lng);
    });
};

export const getI18n = () => i18n;
